import Icon from "@mui/material/Icon"
import { alpha } from "@mui/material/styles"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import colors from "assets/theme/base/colors"

// Report-page-only card: compact header (soft-tint icon + title + optional
// subtitle + right-aligned action) over a flush body. Thinner header, subtler
// border/shadow, and smaller radius than the shared SectionCard — this is
// what keeps the Overview grid from reading as a stack of giant boxes.
const ReportCard = ({
  title,
  subtitle,
  icon,
  color = "info",
  action,
  children,
  minHeight,
  bodyPadding = 2.5,
}) => {
  const tint = colors[color]?.main || colors.info.main
  return (
    <MDBox
      bgColor="white"
      borderRadius="xl"
      height="100%"
      display="flex"
      flexDirection="column"
      sx={{ border: "1px solid", borderColor: "grey.200" }}
    >
      {(title || action) && (
        <MDBox
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          gap={1.5}
          px={2.5}
          py={1.75}
          sx={{ borderBottom: "1px solid", borderColor: "grey.100" }}
        >
          <MDBox display="flex" alignItems="center" gap={1.25} sx={{ minWidth: 0 }}>
            {icon && (
              <MDBox
                width="2rem"
                height="2rem"
                minWidth="2rem"
                borderRadius="lg"
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{ bgcolor: alpha(tint, 0.12), color: tint }}
              >
                <Icon fontSize="small">{icon}</Icon>
              </MDBox>
            )}
            <MDBox sx={{ minWidth: 0 }}>
              {title && (
                <MDTypography
                  variant="button"
                  fontWeight="bold"
                  sx={{ lineHeight: 1.3, display: "block" }}
                >
                  {title}
                </MDTypography>
              )}
              {subtitle && (
                <MDTypography
                  variant="caption"
                  color="text"
                  display="block"
                  sx={{ mt: 0.1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                >
                  {subtitle}
                </MDTypography>
              )}
            </MDBox>
          </MDBox>
          {action && <MDBox sx={{ flexShrink: 0 }}>{action}</MDBox>}
        </MDBox>
      )}
      <MDBox p={bodyPadding} sx={{ flex: 1, minHeight }}>
        {children}
      </MDBox>
    </MDBox>
  )
}

export default ReportCard
